import { MyInternalLink } from 'components/MyLink'
import { useTranslation } from 'react-i18next'

export interface EMSNPageDescriptionProps {
  hasInitialEMSNs?: boolean
  signedUpForEMSNs?: boolean
}

export const EMSNPageDescription = (
  {
    hasInitialEMSNs,
    signedUpForEMSNs
  }: EMSNPageDescriptionProps
) => {
  const { t } = useTranslation('eMSNPage')

  return (
    <div>
      {hasInitialEMSNs && signedUpForEMSNs && (
        <p className='my-u-pb--4'>{t('page-description')}</p>
      )}
      {!hasInitialEMSNs && signedUpForEMSNs && (
        <p className='my-u-pb--4'>
          <span>{t('empty-emsn-results.text-paragraph')}</span>
          <MyInternalLink to='/claims'>
            {t('empty-emsn-results.search-claims-link-text')}
          </MyInternalLink>
        </p>
      )}
      {hasInitialEMSNs && !signedUpForEMSNs && (
        <>
          <p className='my-u-pb--4'>{t('page-description')}</p>
          <p>
            <span className='ds-u-font-weight--bold'>
              {t('you-no-longer-get-emsns.main-note')}
            </span>
            <span>
              {t('you-no-longer-get-emsns.main')}
            </span>
          </p>
          <ol>
            <li><p>{t('you-no-longer-get-emsns.list.go-to-account-settings')}</p></li>
            <li>
              <p>
                <span>{t('you-no-longer-get-emsns.list.select-edit.part-1')}</span>
                <MyInternalLink to='/account-settings'>
                  {t('you-no-longer-get-emsns.list.select-edit.link-text')}
                </MyInternalLink>
                <span>{t('you-no-longer-get-emsns.list.select-edit.part-2')}</span>
              </p>
            </li>
            <li><p>{t('you-no-longer-get-emsns.list.select-yes')}</p></li>
          </ol>
        </>
      )}
      {!hasInitialEMSNs && !signedUpForEMSNs && (
        <>
          <p>{t('how-to-get-original-claim-statements.main')}</p>
          <ul className='ds-c-list'>
            <li><p>{t('how-to-get-original-claim-statements.list.save-to-computer')}</p></li>
            <li><p>{t('how-to-get-original-claim-statements.list.view-emsns-on-this-page')}</p></li>
          </ul>
          <p>{t('how-to-get-original-claim-statements.order-emsn-description')}</p>
        </>
      )}
    </div>
  )
}
